// extracted by mini-css-extract-plugin
export default {"logo":"DineroLogo_logo__ptkPx"};